var header = $('header');
var navigation = $('.head-nav');

navigation.clone().appendTo(".fading-header");

var navigationHeight = navigation.outerHeight();

$(window).on('scroll', function() {
  if($(window).width() > 767){
    if ($(this).scrollTop() >= navigationHeight + 100) {
      $(".fading-header").fadeIn();
    } else {
      $(".fading-header").fadeOut();
    }
  }
});



// WEBPACK FOOTER //
// ./js/modules/_navigation.js